import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconBankbookLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 6.947c0-.537.187-.996.56-1.377A1.83 1.83 0 0 1 4.915 5h14.172c.528 0 .979.19 1.353.57.374.381.561.84.561 1.377v10.106c0 .537-.187.996-.56 1.377a1.83 1.83 0 0 1-1.354.57H4.914a1.83 1.83 0 0 1-1.353-.57A1.895 1.895 0 0 1 3 17.053V6.947Zm1.588 2.9h14.824v-2.9a.319.319 0 0 0-.102-.228.309.309 0 0 0-.224-.104H4.914a.309.309 0 0 0-.224.104.319.319 0 0 0-.102.228v2.9Zm0 1.614v5.592c0 .083.034.159.102.228.068.07.143.104.224.104h14.172a.309.309 0 0 0 .224-.104.319.319 0 0 0 .102-.228v-5.592H4.588Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconBankbookLine;
